const formatToMoneyInput = (value) => {
    // Remove any character that is not a digit or dot
    const cleaned = value.replace(/[^0-9.]/g, '');
  
    // Allow only one decimal point
    const parts = cleaned.split('.');
    const integerPart = parts[0];
    let decimalPart = parts[1];

    // Limit decimals to max 2 digits
    if (decimalPart !== undefined) {
      decimalPart = decimalPart.substring(0, 2);
    }
  
    // Format integer part if it's not empty
    const formattedInteger = integerPart
      ? Number(integerPart).toLocaleString('en-US')
      : '';
  
    // Handle three cases:
    // 1. User is typing a dot (e.g. "1234.")
    // 2. User typed dot and decimals (e.g. "1234.56")
    // 3. No decimals
    if (parts.length === 2) {
      // Preserve the decimal point and anything after it
      return `${formattedInteger}.${decimalPart ?? ''}`;
    } else if (value.endsWith('.')) {
      // If user just typed the dot, preserve it
      return `${formattedInteger}.`;
    } else {
      return formattedInteger;
    }
};
  
  
  export default formatToMoneyInput;
  